import React, { useRef } from 'react'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { hideModal, setModal } from '../../../../app/store/reducers/AppSlice'
import { CreateAffiliateRule, CreateAffiliateRuleRef } from './CreateAffiliateRule'
import { UnsavedChangesModal } from '../unsaved-changes-modal/UnsavedChangesModal'

export const useCreateAffiliateRuleModal = () => {
  const dispatch = useAppDispatch()
  const createAffiliateRuleModal = useRef<CreateAffiliateRuleRef | null>(null)

  return () => {
    const handleClose = () => {
      if (createAffiliateRuleModal?.current?.hasUnsavedChanges()) {
        dispatch(
          setModal({
            children: (
              <UnsavedChangesModal
                onLeave={() => {
                  dispatch(hideModal())
                  dispatch(hideModal())
                }}
              />
            ),
            size: 'md',
          }),
        )
      } else {
        dispatch(hideModal())
      }
    }

    dispatch(
      setModal({
        children: (
          <CreateAffiliateRule
            ref={(ref) => {
              createAffiliateRuleModal.current = ref
            }}
          />
        ),
        size: 'lg',
        onClose: handleClose,
      }),
    )
  }
}
